import FetchClient, { type ApiResponse } from "./FetchClient";

export interface AuditLogChange {
  old: string;
  new: string;
}

export interface AuditLog {
  userId: string;
  timestamp: number;
  changes: Record<string, AuditLogChange>;
}

export async function getAdminUserAuditLogs(userId: string): Promise<AuditLog[]> {
  const response = await FetchClient.get<ApiResponse<AuditLog[]>>(
    `/admin/users/${userId}/audit-logs`
  );
  return response.data;
}

